import * as Yup from "yup";

import IOffer from "@CheckoutStepsOffers/@types/offer";

import { paymentValidations } from "./paymentValidations";

export const getPaymentSchemaValidation = (data, country, offer: IOffer) => {
  const {
    billingInformationSchema,
    creditCardFormSchema,
    creditCardListSchema,
    addressSchema,
  } = paymentValidations();

  const ENABLE_DEFAULT_ADDRESS =
    !!offer?.offer?.details?.enable_default_address;
  const ASK_FOR_ADDRESS = !!offer?.offer?.details?.ask_for_address;
  const IS_CREDIT_CARD_LIST = !!data?.credit_card_list;
  const PAYMENT_METHOD = data?.payment_method;

  if (IS_CREDIT_CARD_LIST) return creditCardListSchema;

  if (ENABLE_DEFAULT_ADDRESS) {
    if (PAYMENT_METHOD === "pix" || PAYMENT_METHOD === "boleto") return null;

    return creditCardFormSchema;
  }

  if (ASK_FOR_ADDRESS && country === "Brasil") {
    if (PAYMENT_METHOD === "credit_card")
      return creditCardFormSchema.concat(
        Yup.object().shape({
          address: addressSchema,
        }),
      );

    return billingInformationSchema;
  } else {
    if (PAYMENT_METHOD === "boleto") return billingInformationSchema;
    if (PAYMENT_METHOD === "credit_card" || country !== "Brasil")
      return creditCardFormSchema;

    return null;
  }
};
